import { useCallback, useState } from 'react'
import { getPreferences, setPreferences as persistPreferences } from '../lib/preferencesStorage'

/**
 * React hook that loads Portfolio Analysis preferences from localStorage on
 * first render and persists every update. Returns:
 *   - prefs       : merged preferences (defaults filled in)
 *   - setPrefs(p) : replaces the full prefs object (caller is responsible
 *                   for merging any partial change). Persists to localStorage.
 */
export function usePortfolioExplorerPreferences (userId) {
  const [prefs, setPrefsState] = useState(() => getPreferences(userId))

  const setPrefs = useCallback((next) => {
    setPrefsState(next)
    persistPreferences(userId, next)
  }, [userId])

  return { prefs, setPrefs }
}
